<div *ngIf="!showManualMigration" class="db-migrate-website-footer__sites-count">
  <p>{{ 'text_hostedSites' | dbText }}</p>
  <b>{{hostedWebsitesCount}} {{ 'text_of' | dbText }} {{hostedWebsitesLimit}}</b>
</div>

<div *ngIf="showManualMigration" class="db-migrate-website-footer__section"></div>

<div class="db-website-install__btn-wrap">
  <button class="ds-btn-black" [disabled]="loading" (click)="submitted.emit()">
    <span *ngIf="!loading">{{ 'text_migrate' | dbText }}</span>
    <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
  </button>
</div>
